import axios from 'axios';
import {
  LaytimeChartReportRequest,
  LaytimePerCounterpartyReportRequest,
  SupplierVsOwnerLaytimeReportRequest,
  useAxios
} from 'hooks';
import { IncoTerm } from 'model';
import { apiBaseUrl } from 'shared/links';

export interface LaytimeByCounterPartyDto {
  deal: string;
  laycan: string;
  quantity: number;
  vessel: string;
  customer: string;
  resultType: string;
  value: number;
  status: string;
  comment: string;
  quarter: string;
  month: string;
  blDate: Date;
  counterpartyName: string;
  counterpartyId: string;
  trafficSpecialist: string;
  trafficSpecialistId: string;
  trafficSpecialistAux: string;
  trafficSpecialistAuxId: string;
  trader: string;
  traderId: string;
  portId: string;
  portName: string;
  counterPartyType: string;
  direction: string;
  receiverIncoTerm: IncoTerm;
  loadingRate: number;
  realLoadingRate: number;
  demurrageRate: number;
  ageInDays: number;
  daysInCalc: number;
}

export interface SupplierVsOwnerDto {
  port: string;
  month: string;
  shipowner: number;
  supplier: number;
  client: number;
  net: number;
}

export interface LaytimeChartDto {
  deal: string;
  parentDeal: string;
  fullDealName: string;
  trafficSpecialist: string;
  trafficSpecialistId: string;
  trafficSpecialistAux: string;
  trafficSpecialistAuxId: string;
  vessel: string;
  client: string;
  currency: string;
  incoTerm: string;
  trader: string;
  traderId: string;
  company: string;
  countryOfDestination: string;
  blDate: Date;
  settleWithSupplier: string;
  settleWithReceiver: string;
  settleWithShipowner: string;
  supplierName: string;
  shipownerName: string;
  loadingPort: string;
  unloadingPort: string;
  product: string;
  rawLoadingSupplier: number;
  rawLoadingReceiver: number;
  rawLoadingShipowner: number;
  rawUnloadingSupplier: number;
  rawUnloadingReceiver: number;
  rawUnloadingShipowner: number;
  rawNetLoading: number;
  rawNetUnloading: number;
  rawProfitAndLoss: number;
  childLoadingSupplier: number;
  childLoadingReceiver: number;
  childLoadingShipowner: number;
  childUnloadingSupplier: number;
  childUnloadingReceiver: number;
  childUnloadingShipowner: number;
  childNetLoading: number;
  childNetUnloading: number;
  childProfitAndLoss: number;
  loadingSupplier: number;
  loadingReceiver: number;
  loadingShipowner: number;
  unloadingSupplier: number;
  unloadingReceiver: number;
  unloadingShipowner: number;
  netLoading: number;
  netUnloading: number;
  profitAndLoss: number;
  quantity: number;
}

const useReportsAPI = () => {
  const { create } = useAxios();
  const qs = require('qs');

  const getLaytimePerCounterpartyreport = async (params: LaytimePerCounterpartyReportRequest) => {
    try {
      const axiosInstance = await create();
      return (
        await axiosInstance.get<LaytimeByCounterPartyDto[]>(`${apiBaseUrl}/api/reports/laytimeByCounterParty`, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              encodeValuesOnly: true
            });
          }
        })
      ).data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(error.response);
      }
    }

    return [];
  };

  const getSupplierVsOwnerreport = async (params: SupplierVsOwnerLaytimeReportRequest) => {
    try {
      const axiosInstance = await create();
      return (
        await axiosInstance.get<LaytimeByCounterPartyDto[]>(`${apiBaseUrl}/api/reports/supplierVsOwner`, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              encodeValuesOnly: true
            });
          }
        })
      ).data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(error.response);
      }
    }

    return [];
  };

  const getLaytimeChartReport = async (params: LaytimeChartReportRequest) => {
    try {
      const axiosInstance = await create();
      return (
        await axiosInstance.get<LaytimeChartDto[]>(`${apiBaseUrl}/api/reports/laytimeChart`, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              encodeValuesOnly: true
            });
          }
        })
      ).data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(error.response);
      }
    }

    return [];
  };

  return {
    getLaytimePerCounterpartyreport,
    getSupplierVsOwnerreport,
    getLaytimeChartReport
  };
};

export default useReportsAPI;
